import { FIELD_TYPES } from "../shared/constants";

const { SELECT_FIELD } = FIELD_TYPES;

export const REFEREE_FILTER_OPTIONS = [
  {
    Name: "Site Of Interest",
    ObjectId: `SiteOfInterest/${SELECT_FIELD}`
  }
];

export const CONTACT_FILTER_OPTIONS = [
  {
    Name: "Email available",
    ObjectId: `HasEmailAddresses/${SELECT_FIELD}`
  },
  {
    Name: "Phone number available",
    ObjectId: `HasPhoneNumbers/${SELECT_FIELD}`
  },
  {
    Name: "Address available",
    ObjectId: `HasAddresses/${SELECT_FIELD}`
  }
];
